import { render, staticRenderFns } from "./UnsubscribePage.vue?vue&type=template&id=20fa0034&scoped=true&"
import script from "./UnsubscribePage.vue?vue&type=script&lang=js&"
export * from "./UnsubscribePage.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribePage.vue?vue&type=style&index=0&id=20fa0034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa0034",
  null
  
)

export default component.exports